import React from 'react';
import PropTypes from "prop-types";

const SalutationDynamic = ({name=''}) => {

    return (
        <section className="coupons-search">
            <div className="container">
                <div className="row">
                    <div className="col-12 pt-4 pb-4">
                        <div className="row pl-2 pr-2">
                            <div className="col-12 d-flex justify-content-lg-start align-content-center">
                                <p className="text-left red-dark m-0 my-auto">
                                    Hola,<br/>
                                    <strong className='text-uppercase'>{name}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

SalutationDynamic.propTypes = {
   name: PropTypes.string
};

export default SalutationDynamic;
